"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDashboardStats = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const PageContent_1 = require("src/configeek_assets/src/components/common/widget/PageContent");
const AdminMGTProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/admin/AdminMGTProvider");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const AdminDashboardStats = () => {
    const context = (0, AdminMGTProvider_1.useAdminMGTContext)();
    const status = context.mgtInfo.status;
    const loading = status.inProgress && !status.loaded;
    const valueRender = node => {
        return loading ? React.createElement(antd_1.Spin, null) : node;
    };
    const information = context.mgtInfo.data;
    const [textTotalLength, textTotalMemory] = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        let length = 0;
        let memory = 0;
        lodash_1.default.each(information === null || information === void 0 ? void 0 : information.activeProjects, v => {
            length += v.info.textLengthTotal;
            memory += v.info.textLengthTotal * 4;
        });
        return [length, memory];
    }, [information === null || information === void 0 ? void 0 : information.activeProjects], lodash_1.default.isEqual);
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.PageContent.Card, null,
            React.createElement(antd_1.Row, { gutter: [32, 16] },
                React.createElement(antd_1.Col, { flex: 1 },
                    React.createElement(antd_1.Statistic, { title: "Projects", value: information === null || information === void 0 ? void 0 : information.projectCount, valueRender: valueRender })),
                React.createElement(antd_1.Col, { flex: 1 },
                    React.createElement(antd_1.Statistic, { title: "Active Projects", value: information === null || information === void 0 ? void 0 : information.activeProjectCount, valueRender: valueRender })),
                React.createElement(antd_1.Col, { flex: 1 },
                    React.createElement(antd_1.Statistic, { title: "Participants Total", value: information === null || information === void 0 ? void 0 : information.participantCount, valueRender: valueRender })),
                React.createElement(antd_1.Col, { flex: 1 },
                    React.createElement(antd_1.Statistic, { title: "Total Text Length, Symbols", value: textTotalLength, valueRender: valueRender })),
                React.createElement(antd_1.Col, { flex: 1 },
                    React.createElement(antd_1.Statistic, { title: "Total Text Memory", value: (0, AdminMGTProvider_1.formatToShortMemory)(textTotalMemory), valueRender: valueRender })))));
};
exports.AdminDashboardStats = AdminDashboardStats;
